import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useMemo } from 'react';
import { PageContentAnimation } from '../../../../components/layout/page-content-animation';
import { PermissionKeys } from '@client/api';
import { PermissionBasedActionButton } from '../../../../components/permission-based-button/permission-based-button';
import { useCreateAgreement } from '../../../../hooks';
import { useUserPermission } from '../../../../hooks/useUserPermission';
import { AgreementsPaths } from '../../agreements.router';

export const AgreementListHeader = () => {
  const { t: tCommon } = useTranslation();
  const { t: tGlobal } = useTranslation('global');
  const { hasAnyPermission } = useUserPermission();

  const { create: createAgreement, isLoading: isCreating } = useCreateAgreement();

  const handleClickCreateAgreement = () => {
    createAgreement();
  };

  const canViewReports = hasAnyPermission([PermissionKeys.Tenant.ReportView]);

  const tabs = useMemo(() => {
    const items = [
      {
        key: 'agreements',
        label: 'Avtaler',
        to: AgreementsPaths.AgreementList,
        end: true,
      },
    ];
    if (canViewReports) {
      items.push({
        key: 'reports',
        label: 'Økonomi',
        to: AgreementsPaths.AgreementReports,
        end: false,
      });
    }
    return items;
  }, [canViewReports]);

  return (
    <>
      <PageContentAnimation className="flex items-start justify-between">
        <div />
        <PermissionBasedActionButton
          color="primary-dark"
          size="md"
          onClick={handleClickCreateAgreement}
          permissions={[PermissionKeys.Tenant.AgreementCreate]}
          title={tCommon('createEntity', { entity: tGlobal('entity.agreement').toLowerCase() })}
          progressing={isCreating}
        />
      </PageContentAnimation>
      <PageContentAnimation className="mb-1">
        <div className="flex gap-8 border-b border-border w-full">
          {tabs.map((tab) => (
            <NavLink
              key={tab.key}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                classNames(
                  'pb-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'text-brand-primary border-b-2 border-brand-primary'
                    : 'text-white hover:text-brand-primary',
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </PageContentAnimation>
    </>
  );
};
